export const presentationData = [
    {
        "id": 1,
        "name": "ASP.NET Core Minimal APIs",
        "URL": "https://gamma.app/docs/ASPNET-Core-Minimal-API-Nedir-4ult8g13unlo7f7"
    },
    {
        "id": 2,
        "name": "HTTP Messages",
        "URL": "https://gamma.app/docs/HTTP-Istek-ve-Yant-Sunumu-y62q73qvfsq74fj"
    },
    {
        "id": 3,
        "name": "Results",
        "URL": "https://gamma.app/docs/ASPNET-Core-Web-APIde-Results-Nesnesi-bt2148jpw2jy64j?mode=doc"
    },
    {
        "id": 4,
        "name": "Global Error Handler",
        "URL": "https://gamma.app/docs/ASPNET-Core-Web-API-icin-Global-Error-Handler-dh3z4h49r9xorhh"
    },
    {
        "id": 5,
        "name": "CORS",
        "URL": "https://gamma.app/docs/API-Guvenligi-icin-CORS-2eztpepcumphn13"
    },
    {
        "id": 6,
        "name": "Swagger",
        "URL": "https://gamma.app/docs/API-Dokumantasyon-ve-Test-icin-Swagger-0b623u2hgvuxwq8"
    },
    {
        "id": 7,
        "name": "Validation",
        "URL": "https://gamma.app/docs/ASPNET-Core-Web-API-Icin-Validation-kxrry63shffkxcf?mode=doc"
    },
    {
        "id": 8,
        "name": "Dependency Injection",
        "URL": "https://gamma.app/docs/ASPNET-Core-Minimal-APIlerde-Bagmllk-Enjeksiyonu-gzheavjczso091b?mode=doc"
    },
    {
        "id": 9,
        "name": "SQLite",
        "URL": "https://gamma.app/docs/SQLite-Nedir-n3fqg1mki2rg5rn?mode=doc"
    },
    {
        "id": 10,
        "name": "Paket Yönetimi",
        "URL": "https://gamma.app/docs/DotNet-Ekosisteminde-Paket-Yonetimi-Teknik-ve-Akademik-Bir-Incele-kckpnqqunfk33g4?mode=doc"
    },
    {
        "id": 11,
        "name": "dotnet tool",
        "URL": "https://gamma.app/docs/Dotnet-Tool-Gelistirici-Verimliliginin-Anahtar-lbm4sl4kkkwb1ru?mode=doc"
    },
    {
        "id": 12,
        "name": "ORM",
        "URL": "https://gamma.app/docs/ORM-Nesne-Iliskisel-Esleme-omr0t09g1j16al3?mode=doc"
    },
    {
        "id": 13,
        "name": "AutoMapper",
        "URL": "https://gamma.app/docs/AutoMapper-ASPNET-Core-Web-API-Projelerinde-Veri-Transferini-Kola-a6vjnj1urcpswwf?mode=doc"
    }
]
